import React from "react";
import "./BulkEdit.css";
import { ReactComponent as ArrowLine } from "../../Assets/svg/arrow_ic_hist.svg";

export const BulkEditTimeline = ({ items }) => {
  if (!items || items.length === 0) return null;

  return (
    <div className="timeline-container d-flex" style={{ position: "relative" }}>
      {/* Left connector column */}
      <div
        style={{
          position: "relative",
          width: "28px",
          flexShrink: 0,
        }}
      >
        <div
          style={{
            position: "absolute",
            top: "16px",
            bottom: "20px",
            left: "8px",
            width: "1.5px",
            backgroundColor: "#DEDEF6",
          }}
        />
      </div>

      <div className="cards-container flex-grow-1" style={{ display: "flex", flexDirection: "column", gap: "12px", marginTop: "4px" }}>
        {items.map((item, i) => {
          const rawValue = item.value ?? "";
          const parts = rawValue.split("->");
          const before = parts[0] ? parts[0].trim() : "";
          const after = parts.length > 1 ? parts.slice(1).join("->").trim() : "";
          const isLongContent = before.length > 55 || after.length > 55 || before.includes("\n") || after.includes("\n") || item.key?.toLowerCase() === "description";

          return (
            <div key={i} className="bulk-card" style={{ position: "relative" }}>
              {/* Branch connector from vertical line to card */}
              <div
                style={{
                  position: "absolute",
                  left: "-20px",
                  top: "22px",
                  width: "20px",
                  height: "12px",
                  borderBottom: "1.5px solid #DEDEF6",
                  borderLeft: "1.5px solid #DEDEF6",
                  borderBottomLeftRadius: "8px",
                  pointerEvents: "none",
                }}
              />

              <div>
                <small
                  className="bulk-label"
                  style={{
                    textTransform: "capitalize",
                    color: "#6929E2",
                    fontWeight: "600",
                    display: "block",
                    marginBottom: "4px",
                  }}
                >
                  {item.key}
                </small>

                {isLongContent ? (
                  <div className="mt-2 d-flex flex-column gap-2">
                    <div
                      style={{
                        padding: "8px 12px",
                        backgroundColor: "#F8F9FA",
                        borderRadius: "8px",
                        border: "1px solid #EDEDF5",
                      }}
                    >
                      <span
                        style={{
                          fontSize: "11px",
                          fontWeight: "700",
                          color: "#8790A1",
                          textTransform: "uppercase",
                          display: "block",
                          marginBottom: "2px",
                        }}
                      >
                        Previous
                      </span>
                      <span
                        style={{
                          fontFamily: "Satoshi",
                          fontSize: "13px",
                          lineHeight: "18px",
                          color: "#555555",
                          wordBreak: "break-word",
                          whiteSpace: "pre-wrap",
                        }}
                      >
                        {before || "None"}
                      </span>
                    </div>

                    <div
                      style={{
                        padding: "8px 12px",
                        backgroundColor: "#F6F1FF",
                        borderRadius: "8px",
                        border: "1px solid #E8DCFF",
                      }}
                    >
                      <span
                        style={{
                          fontSize: "11px",
                          fontWeight: "700",
                          color: "#6929E2",
                          textTransform: "uppercase",
                          display: "block",
                          marginBottom: "2px",
                        }}
                      >
                        Updated
                      </span>
                      <span
                        style={{
                          fontFamily: "Satoshi",
                          fontSize: "13px",
                          lineHeight: "18px",
                          fontWeight: "500",
                          color: "#212129",
                          wordBreak: "break-word",
                          whiteSpace: "pre-wrap",
                        }}
                      >
                        {after || "None"}
                      </span>
                    </div>
                  </div>
                ) : (
                  <div className="d-flex align-items-center flex-wrap gap-2 mt-1">
                    <span
                      style={{
                        fontFamily: "Satoshi",
                        fontWeight: 400,
                        fontSize: "13.5px",
                        color: "#6c757d",
                        wordBreak: "break-word",
                      }}
                    >
                      {before || "None"}
                    </span>
                    <span
                      style={{
                        color: "#6929E2",
                        display: "inline-flex",
                        alignItems: "center",
                      }}
                    >
                      <ArrowLine />
                    </span>
                    <span
                      style={{
                        fontFamily: "Satoshi",
                        fontWeight: 500,
                        fontSize: "13.5px",
                        color: "#212129",
                        wordBreak: "break-word",
                      }}
                    >
                      {after || "None"}
                    </span>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
